'use strict';

import {Popup} from '../popup';
import {sessid} from "../common";
import {lang} from "../common";
import {eventEmitter, isAuth, productWishlist} from '../common/baseData';

class ReportAvailability extends Popup {
	constructor() {
		super('availability');
		this.requestProcessing = false;
	}

	set url(path) {
		this._url = path;
	}

	get url() {
		return this._url;
	}

	set productId(id) {
		this._productId = id;
	}

	get productId() {
		return this._productId;
	}

	set productMerchant(merchant) {
		this._productMerchant = merchant;
	}

	get productMerchant() {
		return this._productMerchant;
	}

	set langId(id) {
		this._langId = id;
	}

	get langId() {
		return this._langId;
	}

	set wishlistPageUrl(url) {
		this._wishlistPageUrl = url;
	}

	get wishlistPageUrl() {
		return this._wishlistPageUrl || (lang === 'ua' ? '/ua/personal/wishlist/' : '/personal/wishlist/');
	}

	set messages(messages) {
		this._messages = messages;
	}

	get messages() {
		return this._messages;
	}

	set requestProcessing(processing) {
		this._requestProcessing = processing;
	}

	get requestProcessing() {
		return this._requestProcessing;
	}

	loadData(body, url) {
		body.sessid = sessid;
		body.lang = lang;
		let data = new FormData();
		for (let key in body) {
			if (!body.hasOwnProperty(key)) continue;
			data.append(key, body[key]);
		}
		return fetch((url) ? url : this.url, {method: "POST", body: data, headers: {"X-Requested-With": "XMLHttpRequest"}});
	}

	addToWishlist() {
		if (this.requestProcessing) return Promise.resolve();

		if (!isAuth) {
			window.sessionStorage.setItem('favoriteProduct', this.productId);
			eventEmitter.emit('showAuth', 'favorite');
			return Promise.resolve();
		}

		this.requestProcessing = true;
		eventEmitter.emit('showLoader');

		return productWishlist.add(Number(this.productId))
			.then(data => {
				if (data && (data.status === 'ok' || this.isAlreadyAddedError(data.error))) {
					this.markWishlistItemsActive();
					this.openSuccessModal();
					return;
				}

				this.openErrorModal();
			})
			.catch(error => {
				console.error(error);
				this.openErrorModal();
			})
				.finally(() => {
					this.requestProcessing = false;
					eventEmitter.emit('hideLoader');
				});
	}

	isAlreadyAddedError(error) {
		if (!error) return false;
		if (Array.isArray(error)) return error.some(item => this.isAlreadyAddedError(item));
		return String(error).toLowerCase().includes('already added');
	}

	markWishlistItemsActive() {
		[].slice.apply(document.querySelectorAll(`[data-container="favorite"][data-id="${this.productId}"]`)).forEach(item => {
			if (item.parentNode instanceof HTMLElement) {
				item.parentNode.classList.add('active');
			}
		});
	}

	openSuccessModal() {
		let modal = new ReportAvailability();
		modal.productId = this.productId;
		modal.wishlistPageUrl = this.wishlistPageUrl;
		modal.messages = this.messages;
		modal.body = modal.renderSuccess();
		modal.open();
	}

	openErrorModal() {
		let modal = new ReportAvailability();
		modal.messages = this.messages;
		modal.body = modal.renderError();
		modal.open();
	}

	message(key) {
		return (this.messages && this.messages.hasOwnProperty(key)) ? this.messages[key] : 'Text not defined.';
	}

	renderSuccess() {
		return `<div class="modal-form-wrap">
			<div class="modal-form-holder">
				<div class="form__modal">
					<div class="success-send-form" style="display: block;">
						<div class="row">
							<div class="modal-title">
								<span>${this.message('SOA_REPORT_AVAILABILITY_SUCCESS_TITLE')}</span>
							</div>
						</div>
						<div class="row">
							<span class="modal-text">${this.message('SOA_REPORT_AVAILABILITY_SUCCESS_TEXT')} <a href="${this.wishlistPageUrl}">${this.message('SOA_REPORT_AVAILABILITY_SUCCESS_LINK')}</a></span>
						</div>
						<div class="row row-centered"><span class="ic-success"></span></div>
					</div>
				</div>
			</div>
		</div>`;
	}

	renderError() {
		return `<div class="modal-form-wrap">
			<div class="modal-form-holder">
				<div class="form__modal">
					<div class="success-send-form" style="display: block;">
						<div class="row">
							<div class="modal-title">
								<span>${this.message('SOA_REPORT_AVAILABILITY_SUCCESS_TITLE')}</span>
							</div>
						</div>
						<div class="row">
							<span class="modal-text">${this.message('SOA_REPORT_AVAILABILITY_ERROR')}</span>
						</div>
					</div>
				</div>
			</div>
		</div>`;
	}
}

export default ReportAvailability;